import { MutationTree } from "vuex";
import { IPropertyEditState } from "../property-states.store";
import propertyDescriptionTypesStore from "./property-description-types.store";
import { IPropertyDescriptionModel, PropertyDescriptionUpdateModel } from "../../../../models/property";
import { itemStateConstant } from "../../../../common";


const descriptionMutations: MutationTree<IPropertyEditState> = <MutationTree<IPropertyEditState>>{
    [propertyDescriptionTypesStore.Set.LIST_OF_PROPERTY_DESCRIPTIONS]:
        (state: IPropertyEditState, descriptions: IPropertyDescriptionModel[]) => {
            state.property.Descriptions = descriptions;
        },

    [propertyDescriptionTypesStore.Set.INSERT_PROPERTY_DESCRIPTIONS]:
        (state: IPropertyEditState, description: IPropertyDescriptionModel) => {
            // get min id 
            let minId = -1;
            if (state.property.Descriptions.length > 0) {
                let addedItems = state.property.Descriptions.filter(x => x.ItemState === itemStateConstant.Added);
                minId = Math.min.apply(Math, addedItems.map(function (o) { return o.Id; }));
            }

            minId = minId - 1;
            description.ItemState = itemStateConstant.Added;
            description.Id = minId;
            state.property.Descriptions.push(description);
        },

    [propertyDescriptionTypesStore.Set.UPDATE_PROPERTY_DESCRIPTION]:
        (state: IPropertyEditState, updateModel: PropertyDescriptionUpdateModel) => {
            if(!state.property.Descriptions)
                return;

            var index = state.property.Descriptions.findIndex(c => c.LanguageId == updateModel.LanguageId)
            if (index > -1) {
                state.property.Descriptions[index][updateModel.Field] = updateModel.Value;
                state.property.Descriptions[index].ItemState = state.property.Descriptions[index].Id ? itemStateConstant.Modified : itemStateConstant.Added;
            }
        },

    [propertyDescriptionTypesStore.Set.DELETE_PROPERTY_DESCRIPTION]:
        (state: IPropertyEditState, id: number) => {
            let item = state.property.Descriptions.filter(x => x.Id === id);
            if (item[0].ItemState === itemStateConstant.Added) {
                let index = state.property.Descriptions.indexOf(item[0]);
                state.property.Descriptions.splice(index, 1);
            }
            else {
                item[0].ItemState = itemStateConstant.Deleted;
            }
        }
}

export default descriptionMutations;